import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_TABLERO = 'ALL_TABLERO';
export const ACTIVO_TABLERO = 'ACTIVO_TABLERO';
export const LOADING_ALL_TABLERO = 'LOADING_ALL_TABLERO';
export const PARAMS_TABLERO = 'PARAMS_TABLERO';
export const PLANEVA_TABLERO = 'PLANEVA_TABLERO';
export const ALL_ESTUDIANTES_PLAN_TABLERO = 'ALL_ESTUDIANTES_PLAN_TABLERO';
export const IS_DISABLED_DATA = 'IS_DISABLED_DATA';

const initialState = {
  all: [],
  activo: null,
  loadingAll: false,
  planEvaluacion: null,
  params: {
    idEntidad: null,
    idPeriodoAcademico: null,
    idDocente: null,
    idBloquePedagogico: null,
    idMateria: null,
    idSeccion: null,
  },
  allEstudiantesPlan: [],
  isDisabledData: false,
};

export const tableroReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_TABLERO:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_TABLERO:
      return {
        ...state,
        activo: action.payload,
      };
    case PLANEVA_TABLERO:
      return {
        ...state,
        planEvaluacion: action.payload,
      };
    case LOADING_ALL_TABLERO:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_TABLERO:
      return {
        ...state,
        params: action.payload,
      };
    case ALL_ESTUDIANTES_PLAN_TABLERO:
      return {
        ...state,
        allEstudiantesPlan: action.payload,
      };
    case IS_DISABLED_DATA:
      return {
        ...state,
        isDisabledData: action.payload,
      };

    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
